import type { ReactNode } from 'react'

/**
 * A filter that says whether it is on in its own markup.
 *
 * `aria-pressed` rather than a class, because that is the fact — the styling
 * hangs off the attribute in `index.css`, so a chip cannot look selected while
 * telling a screen reader it is not.
 */
export function Chip({
  pressed,
  onClick,
  children,
  count,
  title,
}: {
  readonly pressed: boolean
  readonly onClick: () => void
  readonly children: ReactNode
  readonly count?: number
  /** What the filter means, when its words alone don't say. */
  readonly title?: string
}) {
  return (
    <button type="button" className="st-chip" aria-pressed={pressed} onClick={onClick} title={title}>
      {children}
      {count === undefined ? null : <span className="tabular-nums opacity-70">{count}</span>}
    </button>
  )
}
